import React from 'react';

import { FroalaEditorsSettings } from 'src/config/configs';

import { generalMessages } from '../../../../translates/generalMessages';
import { Helmet } from 'react-helmet';
import { FormattedMessage } from 'react-intl';

export const Meta = (props: {
  projectName: string;
  theme: { fontSize: number; sectionWidth: number };
  froalaEditors: FroalaEditorsSettings;
}) => {
  const textWidgetStyle = props.froalaEditors.textWidget;
  return (
    <FormattedMessage id={generalMessages.platformName.id}>
      {(message) => (
        <Helmet>
          <title>{`${props.projectName} · ${message.toString()}`}</title>

          <style>
            {` .student-text-widget p, 
            .student-text-widget li, 
            .student-text-widget td, 
            .student-text-widget th, 
            .home-overview__description p, 
            .home-overview__description li, 
            .home-overview__description td, 
            .home-overview__description th {
              font-size: ${textWidgetStyle.normal.fontSize}px;
              color: ${textWidgetStyle.normal.color};
              line-height: ${textWidgetStyle.normal.lineHeight}%;
              font-weight: ${textWidgetStyle.normal.useBold ? 'bold' : 'normal'};
              ${textWidgetStyle.normal.useItalic ? 'font-style: italic;' : ''}
              ${textWidgetStyle.normal.useUnderline ? 'text-decoration: underline;' : ''}
              margin: ${textWidgetStyle.normal.margin}px 0;
            }       
            .student-text-widget h2 {
              font-size: ${textWidgetStyle.heading2.fontSize}px;
              color: ${textWidgetStyle.heading2.color};
              line-height: ${textWidgetStyle.heading2.lineHeight}%;
              font-weight: ${textWidgetStyle.heading2.useBold ? 'bold' : 'normal'};
              ${textWidgetStyle.heading2.useItalic ? 'font-style: italic;' : ''}
              ${textWidgetStyle.heading2.useUnderline ? 'text-decoration: underline;' : ''}
              margin: ${textWidgetStyle.heading2.margin}px 0;
            }
            .student-text-widget h3 {
              font-size: ${textWidgetStyle.heading3.fontSize}px;
              color: ${textWidgetStyle.heading3.color};
              line-height: ${textWidgetStyle.heading3.lineHeight}%;
              font-weight: ${textWidgetStyle.heading3.useBold ? 'bold' : 'normal'};
              ${textWidgetStyle.heading3.useItalic ? 'font-style: italic;' : ''}
              ${textWidgetStyle.heading3.useUnderline ? 'text-decoration: underline;' : ''}
              margin: ${textWidgetStyle.heading3.margin}px 0;
            }
            .student-text-widget h4 {
              font-size: ${textWidgetStyle.heading4.fontSize}px;
              color: ${textWidgetStyle.heading4.color};
              line-height: ${textWidgetStyle.heading4.lineHeight}%;
              font-weight: ${textWidgetStyle.heading4.useBold ? 'bold' : 'normal'};
              ${textWidgetStyle.heading4.useItalic ? 'font-style: italic;' : ''}
              ${textWidgetStyle.heading4.useUnderline ? 'text-decoration: underline;' : ''}
              margin: ${textWidgetStyle.heading4.margin}px 0;
            }
            .student-text-widget h5 { 
              font-size: ${textWidgetStyle.heading5.fontSize}px;
              color: ${textWidgetStyle.heading5.color};
              line-height: ${textWidgetStyle.heading5.lineHeight}%;
              font-weight: ${textWidgetStyle.heading5.useBold ? 'bold' : 'normal'};
              ${textWidgetStyle.heading5.useItalic ? 'font-style: italic;' : ''}
              ${textWidgetStyle.heading5.useUnderline ? 'text-decoration: underline;' : ''}
              margin: ${textWidgetStyle.heading5.margin}px 0;
            }
            `}
          </style>

          <style>
            {`                           
            .student-columns {
              max-width: ${props.theme.sectionWidth}px;
            }
          `}
          </style>
        </Helmet>
      )}
    </FormattedMessage>
  );
};
